import { Client } from '@stomp/stompjs';
import { environment } from '../../environments/environment';

export function stompBrokerUrl(apiBaseUrl: string = environment.apiBaseUrl): string {
  return `${apiBaseUrl.replace(/^http/, 'ws')}/ws`;
}

export function withBearerHeader(client: Client, tokenProvider: () => Promise<string | null>): void {
  client.beforeConnect = async () => {
    const token = await tokenProvider();
    client.connectHeaders = token ? { Authorization: `Bearer ${token}` } : {};
  };
}
